// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-7W-0m";
var _3 = "rotation-OGnWg";
var _4 = "loading-H1qxG";
var _5 = "content-W11WC";
export { _1 as "__esModule", _2 as "root", _3 as "rotation", _4 as "loading", _5 as "content" }
export default { "__esModule": _1, "root": _2, "rotation": _3, "loading": _4, "content": _5 }
